export const getInterns = '/user/getAllInterns';
export const updateInternStatus = '/user/updateStatus/';
export const getInternsDetails = '/user/getUserById/';
export const getTransaction = '/user/userActivityById/';
export const updateIntern = '/user/';
export const promoteAsEmployee = '/user/';
